// dependencies
import React from "react";

// components
import { Avatar, AvatarSize } from "@performyard/py-components";

// utils
import toEmployeeUrl from "../../utils/URLs/Employee";

import Link from "../Link";
import Tooltip from "../Tooltip";
// styles
import css from "./AvatarGroup.module.scss";

export const getAvatarEntry = (
	hasLinks: boolean,
	canExpand: boolean,
	employeeNameTooltip: boolean,
	employee: { _id: string; name: string },
	style = {},
	size: AvatarSize,
	border = true
) => {
	const avatarContent = (
		<div style={style} className={`${css.avatarContainer} ${border ? "" : css.noBorder}`}>
			<Avatar
				size={size}
				dangerouslySetClassName={css.avatar}
				id={employee._id}
				alt={`${employee.name}'s avatar`}
			/>
		</div>
	);
	if (employeeNameTooltip) {
		return (
			<Tooltip id="avatar-tooltip" message={employee.name}>
				<Link href={`/employee-page/${employee._id}`} forceHardReload={true}>
					{avatarContent}
				</Link>
			</Tooltip>
		);
	}
	if (hasLinks && !canExpand) {
		return (
			<Link href={toEmployeeUrl(employee._id)} forceHardReload={true}>
				{avatarContent}
			</Link>
		);
	}
	return avatarContent;
};
